import { render, staticRenderFns } from "./CreatorOnboardingAlerts.vue?vue&type=template&id=23906074&scoped=true&"
import script from "./CreatorOnboardingAlerts.vue?vue&type=script&lang=js&"
export * from "./CreatorOnboardingAlerts.vue?vue&type=script&lang=js&"
import style0 from "./CreatorOnboardingAlerts.vue?vue&type=style&index=0&id=23906074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23906074",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
